/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Banner,
  Button,
  Card,
  Layout,
  Link,
  TextContainer,
} from '@shopify/polaris';
import styleConstants from 'src/styles/constants';
import { useTenantContext } from 'src/components/TenantProvider';
import getDeepLink from 'src/utils/getDeepLink';
import {
  BANNER,
  THINKIFIC_DASHBOARD,
  UPGRADE_EXPERIENCE,
  LEARN_MORE,
  BUILD_COURSE,
  GET_IN_TOUCH,
} from './constants';

const NextStepsComponent = () => {
  const {
    tenant: { subdomain },
  } = useTenantContext();
  return (
    <>
      <Banner>
        <p>{BANNER.text}</p>
      </Banner>
      <br />
      <Layout>
        <Layout.AnnotatedSection title={THINKIFIC_DASHBOARD.title}>
          <Card sectioned>
            <TextContainer>
              <p>{THINKIFIC_DASHBOARD.text}</p>
              <Button url={getDeepLink(subdomain, 'manage')} external>
                {THINKIFIC_DASHBOARD.button.text}
              </Button>
            </TextContainer>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={UPGRADE_EXPERIENCE.title}>
          <Card>
            <Card.Section>
              <TextContainer>
                <p>{UPGRADE_EXPERIENCE.texts[0]}</p>
                <div className="customize__button__container">
                  <Button
                    url={getDeepLink(
                      subdomain,
                      'manage/settings#remove-thinkific-branding'
                    )}
                    external
                  >
                    {UPGRADE_EXPERIENCE.buttons[0].text}
                  </Button>
                </div>
                <Link url={UPGRADE_EXPERIENCE.links[0]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{UPGRADE_EXPERIENCE.texts[1]}</p>
                <Link url={UPGRADE_EXPERIENCE.links[1]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{UPGRADE_EXPERIENCE.texts[2]}</p>
                <Link url={UPGRADE_EXPERIENCE.links[2]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{UPGRADE_EXPERIENCE.texts[3]}</p>
                <div className="customize__button__container">
                  <Button
                    url={getDeepLink(subdomain, 'manage/settings#site-url')}
                    external
                  >
                    {UPGRADE_EXPERIENCE.buttons[1].text}
                  </Button>
                </div>
                <Link url={UPGRADE_EXPERIENCE.links[3]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{UPGRADE_EXPERIENCE.texts[4]}</p>
                <Link url={UPGRADE_EXPERIENCE.links[4]} external>
                  {LEARN_MORE}
                </Link>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={BUILD_COURSE.title}>
          <Card>
            <Card.Section>
              <TextContainer>
                <p>{BUILD_COURSE.texts[0]}</p>
                <Button
                  url={getDeepLink(subdomain, 'manage/theme_library')}
                  external
                >
                  {BUILD_COURSE.buttons[0].text}
                </Button>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{BUILD_COURSE.texts[1]}</p>
                <Button
                  url={getDeepLink(subdomain, 'manage/site-builder')}
                  external
                >
                  {BUILD_COURSE.buttons[1].text}
                </Button>
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <p>{BUILD_COURSE.texts[2]}</p>
                <Button
                  url={getDeepLink(subdomain, 'manage/settings#site-url')}
                  external
                >
                  {BUILD_COURSE.buttons[2].text}
                </Button>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={GET_IN_TOUCH.title}>
          <Card>
            <Card.Section subdued>
              <TextContainer>
                <p>{GET_IN_TOUCH.text}</p>
                <Button url={GET_IN_TOUCH.button.url} external primary>
                  {GET_IN_TOUCH.button.text}
                </Button>
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
      <style jsx>{`
        .customize__button__container {
          display: inline;
          margin-right: ${styleConstants.spacing.four};
        }
      `}</style>
    </>
  );
};
export default NextStepsComponent;
